import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, Autocomplete, Button, Grid, Stack, TextField, Typography } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import format from 'date-fns/format';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { useTab } from 'src/components/hooks/useTab';
import { useUser } from 'src/components/hooks/useUser';
import { useGetSysAdminNewCodelistQuery } from 'src/services/workarea';
import { AppState, store } from 'src/store';
import { setConfirmExitPopupVal } from 'src/store/confirmPopupVal';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setMessage } from 'src/store/Message';
// import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { QulificationFileData, QulificationReportData } from 'src/types/SQReport';
import { updateUserAccess } from 'src/util/util';
import { usePermissionWrapper } from '../../hooks/usePermissionWrapper';
import SiteInformation from '../steps/SiteInformation';
import { useSiteContactInfo } from '../steps/useSitecontactinfo';
import SQReport from './SQReport';
import './sqReport.scss';
import { useSqReport } from './useSqReport';
import { useCalendarEventByVisitType } from 'src/util/useCalendarEventByVisitType';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import moment from 'moment';
import { archLevel } from 'src/data/config';
import { useGetAssigneesMutation } from 'src/services/Utils';
import { useMonitoringVisitLog } from '../studyLogs/MonitoringVisitLogs/useMonitoringVisitLog';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { hideLoader, showLoader } from 'src/store/Loader';
import { SERVER_DATE_FORMAT } from 'src/constants/formats';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { setSqReportPopupValue, setSqReportStatus, setSqReportTabChange, setReportCMPArr } from 'src/store/sqReport';
import printPdfWithViewer from 'src/components/common/PrintPdfWithViewer';
import { UI_TIME_ZONE } from 'src/constants/formats';
import staticData from '../../../resources/static.json';
import IconButton from '@mui/material/IconButton';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import { DynamicIcon } from '@pihealth/common-ui-library';
import { useGetReportDataQuery } from 'src/services/SqReport';

const SQReportPage: React.FunctionComponent<any> = () => {
  const { setTabVal, tabVal, tabsData } = useTab();
  const currentAppName = archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP;
  const currentTabinfo: any = tabsData.filter((item: any) => item.index === tabVal);
  const selectedRowData: any = useAppSelector(state => state.sqReport.selectedRowData);
  const [expanded, setExpanded] = React.useState(true);
  const [expanded2, setExpanded2] = React.useState(false);
  const [submitBtnText, setSubmitBtnText] = React.useState('Submit');
  const [sitestudySiteInfo, setSitestudySiteInfo] = useState({});
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const [printEnable, setPrintEnable] = useState(false);
  const { user } = useUser();
  const { checkPermission } = usePermissionWrapper();
  const [sqReport, setSqReport] = useState<any>({
    name: ''
  });
  const [sqReportData, setSqReportData] = useState<Partial<QulificationReportData>>({});
  const [isUpdate, setIsUpdate] = React.useState(false);
  const [reviewModelopen, setReviewModelOpen] = React.useState(false);
  const { selectedAppSection } = useSelectedAppInfo();
  const [checkedInStartDate, setCheckedInStartDate] = useState<any>(null);
  const publishReportPermission = checkPermission('publish_sq_report_etmf');
  const isUpdatePublish = sqReportData?.sq_report_publish_version ? true : false;
  const [assigneeList, setAssigneeList] = useState([]);
  const [assigneeValue, setAssigneeValue] = useState<any>();
  const [data1, setData1] = React.useState<any>();
  const dispatch = useDispatch();
  const [agree, setAgree] = useState(false);
  const reviewerName = '';
  const { sqrErrorMsg, sqrMendatoryInfoErrorMsg } = useFieldTranslation();
  const [isSiteContactSaved, setSiteContactSaved] = useState(false);
  const [isQCReportSaved, setQCReportSaved] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const { data: visitCodeListData } = useGetSysAdminNewCodelistQuery('STCONTYP');
  const { data: locationCodeListData } = useGetSysAdminNewCodelistQuery('STLOC');
  const { data: responseCodeListData } = useGetSysAdminNewCodelistQuery('C66742');
  const { data: statusCodeListData } = useGetSysAdminNewCodelistQuery('SUDSTAT');
  const { userPreferedDateFormat } = usePreferedDateFormat();

  const {
    siteStudyPersonnelQueryData,
    getSiteStudyPersonnelQueryData,
    siteStudyPersonnelQueryDataIsSuccess,
    siteStudyPersonnelQueryDataLoading,
    siteTsdaStudyPersonnelQueryData,
    siteTsdaStudyPersonnelQueryDataIsSuccess,
    siteTsdaStudyPersonnelQueryDataLoading
  } = useSiteContactInfo();

  const {
    data: sqReportQueryData,
    error: getsqReportError,
    refetch: getsqReportQueryData
  } = useGetReportDataQuery({
    monitoring_visit_id: selectedRowData.id,
    site_id: selectedSite,
    study_id: studyId,
    country: selectedCountry,
    application: currentAppName
  });

  const {
    createSqReport,
    updateSqReport,
    getStudySitePersonnelQueryData,
    studySitePersonnelQueryData,
    publishSQReportEtmf,
    publishSQReportSuccess
  } = useSqReport();

  const initialState = {
    sq_visit_date: '',
    sq_site_location: 'STLOC',
    sq_site_location_value_code: '',
    sq_type_of_visit: 'STCONTYP',
    sq_type_of_visit_value_code: '',
    sq_personnel: '',
    sq_site_staff: '',
    sq_site_background: '',
    sq_study_activities: '',
    sq_add_site_info: '',
    sq_imp_manage: '',
    sq_site_facilities: '',
    sq_study_records: '',
    sq_regulatory: '',
    sq_reg_approval_bodies: '',
    sq_quality_compliance: '',
    sq_overall_summ: '',
    sq_action_items: '',
    // sq_date_submitted_review: '',
    sq_project_manager: '',
    sq_date_approval: format(new Date(), 'yyyy-MM-dd'),
    sq_site_selected: 'C66742',
    sq_site_selected_value_code: '',
    sq_report_status: 'SUDSTAT',
    sq_report_notify_review: '',
    sq_report_status_value_code: '',
    created_by: '',
    site_id: '',
    study_id: ''
  };
  const [confirmation, setConfirmation] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');
  const submitStatusChange = (event: any) => {
    setSubmitStatus(event.target.value);
    setConfirmExitValue(dispatch, true);
  };

  useEffect(() => {
    if (submitStatus == 'Draft') {
      setSubmitStatus('1');
    } else if (submitStatus == 'Under review') {
      setSubmitStatus('2');
    }
  }, [submitStatus]);

  const dispatchApp = useAppDispatch();
  const handleClickOpen = () => {
    if (
      data1.sq_visit_date == '' ||
      data1.sq_visit_date == null ||
      data1.sq_site_location_value_code == '' ||
      data1.sq_site_location_value_code == null ||
      data1.sq_type_of_visit_value_code == '' ||
      data1.sq_type_of_visit_value_code == null ||
      data1.sq_personnel == '' ||
      data1.sq_personnel == null ||
      data1.sq_site_staff == '' ||
      data1.sq_site_staff == null ||
      // data1.sq_date_approval == '' ||
      // data1.sq_date_approval == null ||
      data1.sq_site_selected_value_code == '' ||
      data1.sq_site_selected_value_code == null ||
      !confirmation
    ) {
      dispatchApp(setMessage({ msgDetails: sqrMendatoryInfoErrorMsg, severity: 'error' }));
    } else {
      if (isSiteContactSaved || isQCReportSaved) {
        setReviewModelOpen(true);
        getAssignees({
          client_name: 'ctms-ui',
          data: ['REVIEWER_SQ_REPORT']
        });
      } else {
        alert('Details entered is not saved. Please save to proceed with Submit');
      }
    }
  };
  const handleClose = () => {
    setReviewModelOpen(false);
  };

  const saveStatus = [
    {
      key: 'Draft',
      label: 'Draft'
    },
    {
      key: 'Under review',
      label: 'Under Review'
    }
  ];

  const confirmReview = () => {
    setReviewModelOpen(false);
    submitData();
  };

  const submitData = () => {
    const filesIDs = fileObjects.map((file: any) => {
      return file.id;
    });
    const reqObj = {
      report_data: { ...sqReportData },
      file_ids: filesIDs,
      is_submit: true
    };
    const temp = `${assigneeValue?.first_name} ${assigneeValue?.last_name}`;
    // need to remove
    delete reqObj.report_data.created_by;
    delete reqObj.report_data.created_on;
    delete reqObj.report_data.deleted_by;
    delete reqObj.report_data.deleted_on;
    delete reqObj.report_data.id;
    delete reqObj.report_data.site_id;
    delete reqObj.report_data.updated_on;

    reqObj.report_data.updated_by = user;
    reqObj.is_submit = true;
    reqObj.report_data.is_submit = true;
    reqObj.report_data.sq_report_status_value_code = submitStatus;
    reqObj.report_data.sq_report_notify_review = temp;
    reqObj.report_data.sq_report_certify_info = true;
    reqObj.report_data.sq_project_manager = temp;
    reqObj.report_data.sq_date_submitted_review = moment().format(SERVER_DATE_FORMAT);
    if (!isUpdate) {
      delete reqObj.report_data.updated_by;
      reqObj.report_data.created_by = user;
      reqObj.report_data.site_id = selectedSite;
      reqObj.report_data.study_id = studyId;
      if (checkedInStartDate) {
        reqObj.report_data.sq_visit_date = moment(checkedInStartDate).format(SERVER_DATE_FORMAT);
      } else {
        reqObj.report_data.sq_visit_date = moment(reqObj.report_data.sq_visit_date).format(SERVER_DATE_FORMAT);
      }
    }
    postData(reqObj);
  };

  const postData = async (reqObj: any) => {
    try {
      if (isUpdate) {
        await updateSqReport({
          site_id: selectedSite,
          study_id: studyId,
          data: reqObj,
          country: selectedCountry,
          application: currentAppName
        });
      } else {
        await createSqReport({
          site_id: selectedSite,
          study_id: studyId,
          data: reqObj,
          country: selectedCountry,
          application: currentAppName
        });
      }

      store.dispatch(dispatchApp(setMessage({ msgDetails: 'Review submitted', severity: 'success' })));
      setQCReportSaved(true);
      getsqReportQueryData();
      setAgree(false);
      setConfirmExitValue(dispatch, false);
    } catch (e) {
      dispatchApp(setMessage({ msgDetails: sqrErrorMsg, severity: 'error' }));
      setQCReportSaved(false);
    }
  };

  const [validationObjSqReportData, setValidationObjSqReportData] = useState<any>({
    sq_visit_date: false,
    sq_site_location_value_code: false,
    sq_type_of_visit_value_code: false,
    sq_date_approval: false,
    sq_site_selected_value_code: false,
    sq_personnel: false,
    sq_site_staff: false
  });
  const [fileObjects, setFileObjects] = useState<QulificationFileData[]>([]);
  const getReportData: any[] = [];
  const [sitePersonnel, setSitePersonnel] = useState([]);
  const [siteStaff, setSiteStaff] = useState([]);
  const [saveDisable, setSaveDisable] = React.useState(false);

  const handleToogleAccordion = () => {
    setExpanded(!expanded);
    setExpanded2(false);
  };
  const handleToogleAccordion2 = () => {
    setExpanded2(!expanded2);
    setExpanded(false);
  };

  useEffect(() => {
    if (siteStudyPersonnelQueryData) {
      setSiteContactSaved(true);
      setSitestudySiteInfo(siteStudyPersonnelQueryData);
    }
  }, [siteStudyPersonnelQueryData]);

  const getData = async () => {
    try {
      await getSiteStudyPersonnelQueryData({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: currentAppName,
        site_users: true,
        strictly_site_users: true
      });
    } catch (error: any) {
      // if (error.response.status === 403) {
      //   dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      // } else if (error.response.status === 401) {
      //   dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      // }
    }
  };

  const { monitoringVisitIsError, monitoringVisitIsLoading, monitoringVisitIsSuccess, getAllMonitoringVisits } =
    useMonitoringVisitLog();

  useEffect(() => {
    if (monitoringVisitIsLoading) {
      dispatchApp(showLoader());
    } else if (monitoringVisitIsSuccess || monitoringVisitIsError) {
      dispatchApp(hideLoader());
    }
  }, [monitoringVisitIsLoading, monitoringVisitIsSuccess, monitoringVisitIsError]);

  const getMonitoringVisitList = async (
    studyId: string | null,
    selectedCountry: string | null,
    selectedSite: string | null,
    currentApp: string
  ) => {
    const allMonitoringResponse: any = await getAllMonitoringVisits({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application_section: selectedAppSection,
      from: 0,
      size: 100
    });
    if (allMonitoringResponse.data && allMonitoringResponse.data.selected_data.length > 0) {
      const sqCheckedInDate: any = allMonitoringResponse?.data?.selected_data.filter(
        (visit: any) => visit.visit_type === 'Site Qualification Visit' && visit?.id === selectedRowData?.id
      );
      if (sqCheckedInDate.length && sqCheckedInDate[0].actual_start_date) {
        setCheckedInStartDate(
          moment(`${sqCheckedInDate[0].actual_start_date.replace(' ', 'T')}Z`).format(
            userPreferedDateFormat.toUpperCase()
          )
        );
      } else {
        setCheckedInStartDate(null);
      }
    } else {
      setCheckedInStartDate(null);
    }
  };

  useEffect(() => {
    getMonitoringVisitList(studyId, selectedCountry, selectedSite, selectedAppSection);
  }, [studyId, selectedCountry, selectedSite]);

  const { getMonitoringEventData } = useCalendarEventByVisitType('Site Qualification Visit');

  useEffect(() => {
    if (sqReportQueryData) {
      (async () => {
        let result: any = {};
        if (
          sqReportQueryData.report_data.sq_visit_date === '' ||
          sqReportQueryData.report_data.sq_visit_date === null
        ) {
          const tempSQVisitDate = await getMonitoringEventData();
          result = {
            ...sqReportQueryData,
            report_data: {
              ...sqReportQueryData.report_data,
              sq_visit_date: tempSQVisitDate
                ? moment(new Date(`${tempSQVisitDate}Z`)).format(userPreferedDateFormat.toUpperCase())
                : ''
            }
          };
        } else {
          result = sqReportQueryData;
        }
        setSqReportData(result.report_data);
        setFileObjects(result.file_data);
        setIsSubmit(result.report_data.is_submit);
        setSaveDisable(result.report_data.is_submit);
        setAgree(result.report_data.sq_report_certify_info);
        setConfirmation(result.report_data.sq_report_certify_info);
        setSubmitStatus(result.report_data.sq_report_status_value_code);
        setQCReportSaved(true);
        if (result?.report_data?.study_id) {
          setIsUpdate(true);
        }
      })();
      if (sqReportQueryData.report_data.sq_report_signature) {
        setSubmitBtnText('Submitted');
      } else if (sqReportQueryData.report_data.is_submit) {
        setSubmitBtnText('Send for Approval');
      } else {
        setSubmitBtnText('Submit');
      }
    }
    setSaveDisable(true);
  }, [sqReportQueryData]);

  useEffect(() => {
    if (getsqReportError) {
      (async () => {
        const tempSQVisitDate = await getMonitoringEventData();
        setSqReportData({
          ...initialState,
          sq_visit_date: tempSQVisitDate
            ? moment(new Date(`${tempSQVisitDate}Z`)).format(userPreferedDateFormat.toUpperCase())
            : ''
        });
        setSaveDisable(true);
        setSubmitBtnText('Submit');
        setIsUpdate(false);
        setSubmitStatus(saveStatus[0].key);
        updateUserAccess(getsqReportError, dispatch);
      })();
    }
  }, [getsqReportError]);

  useEffect(() => {
    if (studySitePersonnelQueryData) {
      setSitePersonnel(studySitePersonnelQueryData);
      setSiteStaff(studySitePersonnelQueryData);
    }
  }, [studySitePersonnelQueryData]);

  useEffect(() => {
    getData();
  }, [selectedSite]);
  useEffect(() => {
    //getSqReportData();
    getsqReportQueryData();
    //getSitePersonnelandSiteStaff();
    getStudySitePersonnelQueryData();
  }, [selectedSite]);

  const confirmexitpopupval: any = useSelector((state: AppState) => state.confirmexitpopupval);
  const handleNextbtn = (_: any) => {
    const popupShowed = localStorage.getItem('popupShowed');
    if (popupShowed == 'true' && confirmexitpopupval.confirmexitpopupval == true) {
      setConfirmExitPopupVal(dispatch, false);
      setConfirmExitPopupVal(dispatch, true);
    }
    if (submitStatus == '2' && !sqReportData.is_submit) {
      dispatch(setSqReportPopupValue(true));
    }
    setTabVal(tabVal + 1);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (submitStatus == '2' && !sqReportData.is_submit) {
      dispatch(setSqReportTabChange(true));
    } else {
      dispatch(setSqReportTabChange(false));
    }
  }, [submitStatus, sqReportData]);

  const [
    getAssignees,
    { isLoading: isAssingeeLoading, data: assignees, isError: isAssingeeError, isSuccess: isAssingeeSuccess }
  ] = useGetAssigneesMutation();

  useEffect(() => {
    if (isAssingeeLoading && !isAssingeeSuccess && !isAssingeeError) {
      dispatch(showLoader());
    } else if (!isAssingeeLoading && isAssingeeSuccess) {
      setAssigneeList(assignees);
    } else if (isAssingeeError) {
      console.error('error');
    }
    dispatch(hideLoader());
  }, [isAssingeeLoading, isAssingeeError, isAssingeeSuccess, assignees]);

  const sqReportStatus: any = useSelector((state: any) => state.sqReport.sqReportStatus);

  useEffect(() => {
    if (sqReportStatus) {
      setSubmitStatus(sqReportStatus);
    }
    dispatch(setSqReportStatus(''));
  }, [sqReportStatus]);

  const handlePublishSQReport = async () => {
    let version: any = 0;
    if (isUpdatePublish) {
      version = Math.floor(Number(sqReportData?.sq_report_publish_version)) + 1;
    } else {
      version = '1';
    }
    if (publishReportPermission) {
      try {
        dispatch(showLoader());
        await publishSQReportEtmf({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          monitoring_visit_id: selectedRowData?.id,
          publish_doc_version: parseFloat(version).toFixed(1),
          is_published: true,
          update: isUpdatePublish,
          application: currentAppName,
          application_section: selectedAppSection
        });
        dispatch(hideLoader());
        await getsqReportQueryData();
      } catch (error: any) {
        dispatch(hideLoader());
        if (error && error?.response?.status === 403) {
          dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
        } else if (error && error.response?.status === 401) {
          dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
        } else {
          dispatch(setMessage({ msgDetails: 'Error while publishing', severity: 'error' }));
        }
      }
    }
    setConfirmExitValue(dispatch, false);
  };

  useEffect(() => {
    if (publishSQReportSuccess) {
      dispatchApp(
        setMessage({
          msgDetails: ` ${selectedRowData.visit_name} successfully published to ETMF`,
          severity: 'success'
        })
      );
      setPrintEnable(true);
    }
  }, [publishSQReportSuccess]);

  const printSQCL = async () => {
    try {
      dispatch(showLoader());
      const options = {
        sq_visit_id: selectedRowData?.id,
        template_name: 'site_qualification_report',
        study_id: studyId,
        site_id: selectedSite,
        pathVariables: {
          time_zone_id: UI_TIME_ZONE,
          country: selectedCountry,
          appName: currentAppName
        }
      };
      printPdfWithViewer('get_sqconfirmationletter_pdf_file', options, 'application/pdf');
      setTimeout(() => {
        dispatch(hideLoader());
      }, 1500);
    } catch (error: any) {
      dispatch(hideLoader());
      dispatch(setMessage({ msgDetails: 'Error while fetching pdf', severity: 'error' }));
    }
    setConfirmExitValue(dispatch, false);
  };

  const handelBackButton = () => {
    dispatch(setReportCMPArr('sqreportview'));
  };
  useEffect(() => {
    return () => {
      handelBackButton();
    };
  }, []);

  return (
    <>
      {checkPermission('view_sq_report') || checkPermission('view_sq_report_after_submit') ? (
        <>
          <Grid container mb={2} mt={-1}>
            <Grid item md={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Button
                onClick={handelBackButton}
                key={staticData.sqChecklistView.back_button}
                startIcon={<DynamicIcon name={staticData.sqChecklistView.icon} />}
              >
                {staticData.sqChecklistView.back_button_name}
              </Button>

              <Stack direction="row" spacing={1.5}>
                <Button
                  variant="contained"
                  sx={{ alignSelf: 'center', textTransform: 'none' }}
                  disabled={
                    !sqReportData.sq_report_signature || sqReportData?.is_published === true || !publishReportPermission
                  }
                  onClick={() => handlePublishSQReport()}
                >
                  PUBLISH TO eTMF
                </Button>

                <IconButton
                  aria-label="Print"
                  color="primary"
                  sx={{ alignSelf: 'center' }}
                  onClick={() => printSQCL()}
                  disabled={sqReportData?.is_published === true ? false : !printEnable}
                >
                  <LocalPrintshopIcon />
                </IconButton>
              </Stack>
            </Grid>
          </Grid>

          <div className="pi-accordion lastAccordionSetting2">
            <Accordion expanded={expanded} onChange={handleToogleAccordion}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                <Typography>Site Information</Typography>
              </AccordionSummary>
              {Object.keys(sitestudySiteInfo).length !== 0 && (
                <SiteInformation
                  siteStudyPersonnelQueryData={siteStudyPersonnelQueryData}
                  siteTsdaStudyPersonnelQueryData={siteTsdaStudyPersonnelQueryData}
                  siteStudyPersonnelQueryDataIsSuccess={siteStudyPersonnelQueryDataIsSuccess}
                  siteTsdaStudyPersonnelQueryDataIsSuccess={siteTsdaStudyPersonnelQueryDataIsSuccess}
                  siteStudyPersonnelQueryDataLoading={siteStudyPersonnelQueryDataLoading}
                  siteTsdaStudyPersonnelQueryDataLoading={siteTsdaStudyPersonnelQueryDataLoading}
                  ItIsSQ
                />
              )}
            </Accordion>

            <Accordion expanded={expanded2} onChange={handleToogleAccordion2}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
                <Typography sx={{ width: '33%', flexShrink: 0 }}>Qualification Report</Typography>
              </AccordionSummary>
              {Object.keys(sitestudySiteInfo).length !== 0 && (
                <SQReport
                  setAgree={setAgree}
                  agree={agree}
                  sqReport={sqReport}
                  sitestudySiteInfo={sitestudySiteInfo}
                  setSqReport={setSqReport}
                  getReportData={getReportData}
                  getSqReportData={getsqReportQueryData}
                  setSqReportData={setSqReportData}
                  sqReportData={sqReportData}
                  fileObjects={fileObjects}
                  setFileObjects={setFileObjects}
                  siteStaff={siteStaff}
                  validationObjSqReportData={validationObjSqReportData}
                  setValidationObjSqReportData={setValidationObjSqReportData}
                  sitePersonnel={sitePersonnel}
                  isUpdate={isUpdate}
                  reviewerName={reviewerName}
                  setData1={setData1}
                  isQCReportSaved={isQCReportSaved}
                  setQCReportSaved={setQCReportSaved}
                  saveDisable={saveDisable}
                  confirmation={confirmation}
                  setConfirmation={setConfirmation}
                  submitStatus={submitStatus}
                  setSubmitStatus={setSubmitStatus}
                  submitStatusChange={submitStatusChange}
                  saveStatus={saveStatus}
                  createSqReport={createSqReport}
                  updateSqReport={updateSqReport}
                  VisitCodeListData={visitCodeListData}
                  LocationCodeListData={locationCodeListData}
                  ResponseCodeListData={responseCodeListData}
                  StatusCodeListData={statusCodeListData}
                  checkedInStartDate={checkedInStartDate}
                  setSaveDisable={setSaveDisable}
                />
              )}
            </Accordion>
            <Grid container spacing={2} className="bottom-navigation">
              <Grid item md={12} display="flex" justifyContent="flex-end">
                <Stack spacing={2} direction="row">
                  {/* {checkPermission('update_sq_report') && !checkPermission('view_sq_report_after_submit') ? ( */}
                  {checkPermission('update_sq_report') ? (
                    <Button
                      variant="contained"
                      disabled={
                        isSubmit ||
                        (!agree && (!isSiteContactSaved || !isQCReportSaved)) ||
                        (submitStatus != '2' ? true : agree ? false : true) ||
                        !sqReportData.created_by
                      }
                      onClick={handleClickOpen}
                    >
                      {submitBtnText}
                    </Button>
                  ) : (
                    <></>
                  )}
                  <PopupComponent open={reviewModelopen} maxWidth="md">
                    <DialogTitle>Confirm</DialogTitle>
                    <DialogContent sx={{ minWidth: 400, minHeight: 120 }}>
                      <Autocomplete
                        className="customNamePicker"
                        id="sq-report-user-signature"
                        options={assigneeList}
                        autoComplete
                        // for filtering the autocomplete list with atleast 3 characters
                        getOptionLabel={option => {
                          return `${option?.first_name} ${option?.last_name} (${option?.email})`;
                        }}
                        filterOptions={(options: Array<any>, state: any) => {
                          let filteredOption: any = [];
                          filteredOption = options.filter((item: any) => {
                            const temp = `${item?.first_name} ${item?.last_name} (${item?.email})`;
                            if (state?.inputValue?.length >= 3) {
                              if (
                                temp.toLowerCase() === state?.inputValue.toLowerCase() ||
                                temp.toLowerCase().includes(state?.inputValue.toLowerCase())
                              ) {
                                return item;
                              }
                            }
                          });
                          return filteredOption;
                        }}
                        onChange={(event, newValue) => {
                          setAssigneeValue(newValue);
                        }}
                        value={assigneeValue || null}
                        renderInput={(params: any) => (
                          <TextField
                            error={false}
                            required
                            {...params}
                            label="Notify Users for Review"
                            placeholder="Notify Users for Review"
                            InputLabelProps={{
                              style: {
                                marginLeft: '-10px'
                              }
                            }}
                          />
                        )}
                      />
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleClose} className="grey-btn">
                        Cancel
                      </Button>
                      <Button onClick={confirmReview} disabled={!assigneeValue}>
                        Ok
                      </Button>
                    </DialogActions>
                  </PopupComponent>
                  {currentTabinfo[0].NextButton && (
                    <Button variant="contained" onClick={handleNextbtn}>
                      NEXT
                    </Button>
                  )}
                </Stack>
              </Grid>
            </Grid>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default SQReportPage;
